<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div *ngIf="isLoading" class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div
      *ngIf="activationSuccess"
      class="card-footer alert alert-success col-12 col-xs-9 col-lg-8"
    >
      IMPORTANT: Activation Successful - Please login to your account and start adding your houshold members by clicking
      <a
        href="https://{{ tenantSubdomain }}.{{ getDomain() }}.org/myprofile"
        >here</a
      >
    </div>
    <div
      *ngIf="activationFailure"
      class="card-footer alert alert-danger col-12 col-xs-9 col-lg-8"
    >
      An error occurred during activation. You are trying to activate your
      account using an outdated email. Please check the latest activation email.
      <a
        href="https://{{ tenantSubdomain }}.{{ getDomain() }}.org/signup"
        >here</a
      >. login.
    </div>
  </div>
</div>
